/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import SettingsIcon from 'icons/SettingsIcon';

const messages = defineMessages({
  title: {id: 'navigation.educator-merit-pay.annual-evaluation-settings'},
});

const AnnualEvaluationSettingsItem = () => (
  <RouteLinkItem
    iconBefore={SettingsIcon}
    route="midas/educator-merit-pay/annual-evaluation-settings"
    title={messages.title}
  />
);

export default AnnualEvaluationSettingsItem;
